<template>
    <div class="heartGroundDetail margin-top containerStyle">
           <div class="psyDetail" >
               <div>
                   <div class="articleHead">
                       <h1>
                           {{ArticleDetail.title}}
                       </h1>
                       <p>
                           <span>
                               {{ArticleDetail.createdAt}}
                           </span>
                           <span>
                               {{ArticleDetail.viewsStr}}
                           </span>
<!--                           <span>-->
<!--                               <el-button type="primary" size="mini" @click="getArticleFav(ArticleDetail.id,true)" v-if="shoucang">-->
<!--                                   收藏此文章-->
<!--                               </el-button>-->
<!--                               <el-button type="success" size="mini" @click="getArticleFav(ArticleDetail.id,false)" v-if="!shoucang">-->
<!--                                   已收藏-->
<!--                               </el-button>-->
<!--                           </span>-->

                       </p>
                   </div>
                   <div class="PsyLead">
                       <b>
                         导语:
                       </b>
                       {{ArticleDetail.description}}
                   </div>
                   <div v-html="ArticleDetail.content">

                   </div>
               </div>

           </div>
        <div class="rmdTest">
           <h1>
               同类推荐
           </h1>
            <ul class="padding-b">
                <li v-for="(item,index) in ArticleRecommend" :key="index" @click="getArticle(item.id)">
                    <img :src="item.coverImg" alt="">
                     <div class="text-m-size text-two-ellipsis padding-x font-weight-bold">
                          {{item.title}}
                     </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import{
        soulArticleDetail,
        soulArticleRecommend,
        soulArticleFav

    } from '../../../config/index'
    export default {
        name: "heartGroundDetail",
        data(){
            return{
              ArticleDetail:[],
                ArticleRecommend:[],
                shoucang:true,
                shoucang1:false
            }
        },
        mounted(){
            this.Id = this.$route.query.id;
            this.getArticleDetail(this.Id);
        },
        methods:{
            async getArticleDetail(val){

                let res = await soulArticleDetail(val);
                if (res.status){
                    window.scrollTo(0,0);
                    this.ArticleDetail = res.data;

                }
            },
            //获取推荐文章
            async getArticleRecommend(){
                let res = await soulArticleRecommend();
                if (res.status){
                    this.ArticleRecommend = res.data;

                }
            },
            async getArticleFav(val,val1){
                let res = await soulArticleFav(val,val1);
                this.shoucang = !this.shoucang;
                if (res.status){

                }
            },
            getArticle(val){
                this.getArticleDetail(val);
            }


        },
        created() {
            //this.getArticleDetail();
            this.getArticleRecommend();
        }
    }
</script>

<style scoped lang="scss">
.heartGroundDetail{
    .psyDetail{
        line-height: 200%;
        color: #666;
        font-size: 16px;
        margin-bottom: 30px;
        background-color: #fff;
        padding: 40px 100px;
        .articleHead{
            text-align: center;
            border-bottom: 1px solid #eee;
            h1 {
                font-size: 24px;
                line-height: 35px;
                color: #333;
                margin-bottom: 10px;
            }
            p {
                color: #999;
                font-size: 14px;
                margin-bottom: 5px;
                span{
                    margin: 0 15px;
                }
            }
        }
        .PsyLead{
            padding: 25px 50px;
            max-height: 90px;
            font-size: 14px;
            background: url('../img/psy_article.png') no-repeat center top;
            color: #2678BD;
            overflow: hidden;
            margin-bottom: 30px;
            background-size: 100% 100%;
             b {
                font-size: 16px;
            }
        }
    }
    .rmdTest{
        margin-bottom: 30px;
        h1 {
            line-height: 45px;
            color: #333;
            font-size: 24px;
        }
        ul{
            margin-right: -20px;
            margin-top: 10px;
            list-style: none;
            li {
                background-color: #fff;
                width: 235px;
                height: 226px;
                margin-right: 20px;
                display: inline-block;
                img {
                    width: 235px;
                    height: 156px;
                }
                h2 {
                    padding: 3px 10px 0;
                }
            }
        }
    }

}
</style>
